import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.m,
  },
  tableContainer: {
    '&&': {
      marginTop: SPACES.xxxxxl,
    },
  },
  tableHeadCell: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.grey2,
    },
  },
  tableBodyCell: {
    '&&': {
      fontSize: 11,
      color: theme.palette.custom.darkBlue2,
    },
  },
  tableBodyCellBold: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
    },
  },
  linkIcon: {
    '&&': {
      width: 20,
      heigh: 20,
      color: theme.palette.custom.grey2,
    },
  },
}))
